module.exports = __webpack_public_path__ + "static/img/summer_jianjiePic.8a83d77c.png";